import { Box, Flex, type FlexProps, Text } from '@/components';
import {
  LEDGER_BG_COLOR,
  LEDGER_BORDER,
  LEDGER_MIDDLE_CAPTION_WIDTH,
  LEDGER_PADDING,
} from '@/features/mold/utils';
import {
  type FC,
  type PropsWithChildren,
  type ReactNode,
  isValidElement,
} from 'react';

type SectionItemProps = {
  wrapperStyle?: FlexProps['style'];
  title?: ReactNode;
  titleWrapperStyle?: FlexProps['style'];
  titleContentStyle?: FlexProps['style'];
};

export const SectionItem: FC<PropsWithChildren<SectionItemProps>> = ({
  wrapperStyle,
  title,
  titleWrapperStyle,
  titleContentStyle,
  children,
}) => {
  return (
    <Flex
      gap={2}
      style={{
        border: LEDGER_BORDER,
        ...wrapperStyle,
      }}
    >
      {title && (
        <Flex
          style={{
            justifyContent: 'center',
            alignItems: 'flex-start',
            width: LEDGER_MIDDLE_CAPTION_WIDTH,
            padding: LEDGER_PADDING,
            borderRight: LEDGER_BORDER,
            backgroundColor: LEDGER_BG_COLOR,
            boxSizing: 'border-box',
            ...titleWrapperStyle,
          }}
        >
          {isValidElement(title) ? (
            <>{title}</>
          ) : (
            <Flex
              align="center"
              style={{
                padding: LEDGER_PADDING,
                ...titleContentStyle,
              }}
            >
              <Text
                variant="footnote"
                style={{ textAlign: 'center' }}
                text={title as string | number}
              />
            </Flex>
          )}
        </Flex>
      )}
      <Box width="100%">{children}</Box>
    </Flex>
  );
};
